import noop from 'utils/noop';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { DisplayPriorityCampaign } from 'modules/placements/types';

export const CONFIRM_DISPLAY_PRIORITY_MODAL = 'confirm-default-display-priority-modal';

type Props = {
  campaignDisplayPriorityOrder?: DisplayPriorityCampaign[];
  isOpen?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  onSelectDisplayPriority?: () => void;
};

export const ConfirmDefaultDisplayPriorityModal = ({
  campaignDisplayPriorityOrder = [],
  isOpen = true,
  onClose = noop,
  onConfirm = noop,
  onSelectDisplayPriority = noop,
}: Props) => {
  const campaignsLength = campaignDisplayPriorityOrder?.length;
  return (
    <Modal
      data-test={CONFIRM_DISPLAY_PRIORITY_MODAL}
      id={CONFIRM_DISPLAY_PRIORITY_MODAL}
      onClose={onClose}
      isModalOpen={isOpen}
      withPortal
    >
      <ModalHeader autoFocus={false}>Set campaign to the highest display priority?</ModalHeader>
      <ModalBody>
        {'Campaign will automatically have the '}
        {campaignsLength > 0 ? (
          <>
            display priority <strong>1st of {campaignsLength}</strong>
          </>
        ) : (
          'highest display priority'
        )}
        {' if not specified.'}
      </ModalBody>
      <ModalFooter>
        <SecondaryButton
          data-test={`${CONFIRM_DISPLAY_PRIORITY_MODAL}-open-takeover-button`}
          onClick={onSelectDisplayPriority}
        >
          Select display priority
        </SecondaryButton>
        <PrimaryButton
          data-test={`${CONFIRM_DISPLAY_PRIORITY_MODAL}-confirm-button`}
          onClick={onConfirm}
        >
          Confirm display priority
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
